module.exports = __webpack_public_path__ + "img/yuan.c159ddb1.svg";